import { marketplaceService } from "../services/marketplaceService";
import { orderService } from "../services/orderService";
import { packetService } from "../services/packetService";

export function useMarketplace() {
  return {
    listings: marketplaceService.listListings(),
    orders: orderService.listOrders(),
    bids: orderService.listBids(),
    holdRequests: orderService.listHoldRequests(),
    packets: packetService.listPackets(),
    pharmacies: marketplaceService.listPharmacies(),
  };
}
